export default __webpack_public_path__ + "static/media/SWT0520.34I-18759_-14566_0.71088aba.jpg";